import React from 'react';
import Modal from '../../components/modal/modal';
import axiosInstance from '../../AxiosInstance';
import { formatTimestamp } from '../../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import idStyles from '../invoice_detail/invoiceDetailModal.module.css';

export function getBillAttachedFiles(invoice) {
    const files = [...(invoice?.bill_attached_files ?? [])];
    files.sort((a, b) => {
        const ta = a.upload_date ? new Date(a.upload_date).getTime() : 0;
        const tb = b.upload_date ? new Date(b.upload_date).getTime() : 0;
        return ta - tb;
    });
    return files;
}

function downloadFile(id, name) {
    axiosInstance
        .get(`file/${id}/`, {
            responseType: 'blob',
        })
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${name}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        });
}

export default function BillAttachmentsModal({ show, setter, invoice }) {
    const files = invoice ? getBillAttachedFiles(invoice) : [];
    const titleSn = invoice?.sn ? ` [${invoice.sn}]` : '';

    return (
        <Modal show={show} setter={setter} name={`Archivos adjuntos${titleSn}`}>
            <table className={idStyles.modernTable}>
                <thead>
                    <tr>
                        <th>Fecha de Subida</th>
                        <th>Tipo de documento</th>
                        <th>Nombre del Archivo</th>
                        <th>Descargar</th>
                    </tr>
                </thead>
                <tbody>
                    {files.length === 0 ? (
                        <tr>
                            <td colSpan={4} className={idStyles.emptyCell}>
                                No hay archivos adjuntos
                            </td>
                        </tr>
                    ) : (
                        files.map((file) => (
                            <tr key={file.id}>
                                <td>{formatTimestamp(file.upload_date)}</td>
                                <td>{file.type ?? '-'}</td>
                                <td>{file.name}</td>
                                <td
                                    role="button"
                                    onClick={() => downloadFile(file.id, file.name)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <FontAwesomeIcon icon={faDownload} size="sm" />
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </Modal>
    );
}
